<template>
  <v-main>
    <v-container fluid>
      <v-stepper v-model="e1" class="unitCreateDialog">
        <v-col cols="12">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="#6c5dd4"
            dark
            @click="$router.back()"
          >
            <v-icon size="15" dark> mdi-arrow-left </v-icon> </v-btn
          >Add Unit
        </v-col>
        <v-stepper-header elevation="8">
          <v-stepper-step color="#6c5dd4" editable :complete="e1 > 1" step="1">
            Customer/Controller Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step color="#6c5dd4" editable :complete="e1 > 2" step="2">
            Pump & Motor/RMS Details
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="py-2 px-1">
            <v-card class="mb-12" elevation="0">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6"> Enter Customer Basic Details </span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">First Name * </label>
                    <vs-input
                      primary
                      v-model="Createform.first_name"
                      placeholder="Email"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-account"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.first_name ? errors.first_name : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Mobile no * </label>
                    <vs-input
                      primary
                      v-model="Createform.phone_no"
                      placeholder="Enter a mobile no."
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-phone"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.phone_no ? errors.phone_no : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Email * </label>
                    <vs-input
                      primary
                      v-model="Createform.email"
                      placeholder="Enter a email *"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-email"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.email ? errors.email : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col
                    lg="6"
                    xl="6"
                    md="6"
                    sm="12"
                    cols="12"
                    class="px-1 d-flex align-center mt-4"
                  >
                    <label for="" class="text-caption">Is Active</label>
                    <v-col lg="2" xl="2" md="2" sm="3" cols="3">
                      <vs-switch color="#6c5dd4" v-model="Createform.is_active">
                        <template #off> No </template>
                        <template #on> Yes </template>
                      </vs-switch>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6"> Enter Controller Details </span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Serial no. </label>
                    <vs-input
                      primary
                      v-model="Createform.serial_no_controller"
                      placeholder="Controller serial number "
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-counter"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.serial_no_controller
                            ? errors.serial_no_controller
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption"
                      >Controller Location *
                    </label>
                    <vs-input
                      primary
                      v-model="Createform.location_controller"
                      placeholder="Controller Location."
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-map-marker-distance"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.location_controller
                            ? errors.location_controller
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Location </label>
                    <vs-input
                      primary
                      v-model="Createform.location"
                      placeholder="Location"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-crosshairs"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.location ? errors.location : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Latitude </label>
                    <vs-input
                      primary
                      v-model="Createform.latitude"
                      placeholder="Latitude"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-latitude"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.latitude ? errors.latitude : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Longitude </label>
                    <vs-input
                      primary
                      v-model="Createform.longitude"
                      placeholder="Longitude"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-longitude"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.longitude ? errors.longitude : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Vendor Code </label>
                    <vs-input
                      primary
                      v-model="Createform.vendor_code"
                      placeholder="Vendor Code"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-qrcode-edit"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.vendor_code ? errors.vendor_code : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption"
                      >Controller Manufacturer
                    </label>
                    <vs-input
                      primary
                      v-model="Createform.manufacturer_vfd"
                      placeholder="Controller Manufacturer"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-truck-outline"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.manufacturer_vfd
                            ? errors.manufacturer_vfd
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6"> Enter Location Details </span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Village </label>
                    <vs-input
                      primary
                      v-model="Createform.village"
                      placeholder="Village"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-home-city"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.village ? errors.village : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">State </label>
                    <vs-input
                      primary
                      v-model="Createform.state"
                      placeholder="State"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-map"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.state ? errors.state : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">District </label>
                    <vs-input
                      primary
                      v-model="Createform.district"
                      placeholder="District"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-map-marker"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.district ? errors.district : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Scheme Name </label>
                    <vs-input
                      primary
                      v-model="Createform.scheme_name"
                      placeholder="Scheme Name"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-file-document"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.scheme_name ? errors.scheme_name : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">IMIS SchemeID </label>
                    <vs-input
                      primary
                      v-model="Createform.imis_scheme_id"
                      placeholder="IMIS SchemeID"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-identifier"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.imis_scheme_id ? errors.imis_scheme_id : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Division </label>
                    <vs-input
                      primary
                      v-model="Createform.division"
                      placeholder="Division"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-city"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.division ? errors.division : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Block </label>
                    <vs-input
                      primary
                      v-model="Createform.block"
                      placeholder="Block"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-cube-outline"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.block ? errors.block : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Panchayet </label>
                    <vs-input
                      primary
                      v-model="Createform.panchayet"
                      placeholder="Panchayet"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-home-group"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.panchayet ? errors.panchayet : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Habitation </label>
                    <vs-input
                      primary
                      v-model="Createform.habitation"
                      placeholder="Habitation"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-home-outline"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.habitation ? errors.habitation : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <vs-button
              color="#6c5dd4"
              class="float-end px-3 text-subtitle-2"
              dark
              @click="e1 = 2"
            >
              Continue
            </vs-button>

            <v-btn text class="float-end text-subtitle-2 mt-2" to="/units"
              >Cancel</v-btn
            >
          </v-stepper-content>

          <v-stepper-content step="2" class="py-2 px-1">
            <v-card class="mb-12" elevation="0" color="">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6">Enter Pump & Motor Details</span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Pump Serial No </label>
                    <vs-input
                      primary
                      v-model="Createform.pump_serial_no"
                      placeholder="Pump Serial No"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-pump"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.pump_serial_no
                            ? errors.pump_serial_no
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col
                    xl="6"
                    lg="6"
                    md="6"
                    sm="12"
                    cols="12"
                    class="px-1 mt-1"
                  >
                    <label for="">Pump Category</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      v-model="Createform.motor_category"
                      :items="PumpCategories"
                      dense
                      label="Pump Category"
                      solo
                      :error-messages="errors.motor_category"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Motor Type</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      v-model="Createform.motor_type"
                      :items="[{text: 'AC', value: 'AC'}, {text: 'DC', value: 'DC'}]"
                      item-text="text"
                      item-value="value"
                      dense
                      label="Motor Type"
                      solo
                      :error-messages="errors.motor_type"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Motor Hp</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      v-model="Createform.motor_hp"
                      :items="MotorHps"
                      dense
                      label="Motor Hp"
                      solo
                      :error-messages="errors.motor_hp"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Motor Head Size</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      v-model="Createform.motor_head_size"
                      :items="HeadPumpSizes"
                      dense
                      label="Motor Head Size"
                      solo
                      :error-messages="errors.motor_head_size"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6">Enter RMS Details</span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Imei No </label>
                    <vs-input
                      primary
                      v-model="Createform.imei_number"
                      placeholder="Pump Serial No"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-pump"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.imei_number ? errors.imei_number : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">RMS Phone no </label>
                    <vs-input
                      primary
                      v-model="Createform.rms_phone_no"
                      placeholder="Pump Serial No"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-pump"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.rms_phone_no
                            ? errors.rms_phone_no
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <vs-button
              color="#6c5dd4"
              elevation="0"
              class="float-end px-3 text-subtitle-2"
              :loading="isLoading"
              dark
              @click="save"
            >
              Save
            </vs-button>

            <v-btn text @click="e1 = 1" class="float-end mt-1">
              previous
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "UnitsCreatePage",
  data() {
    return {
      Createform: {
        is_active: true,
      },
      e1: 1,
      vendors: [],
      MotorTypes: [],
      PumpCategories: [],
      MotorHps: [],
      HeadPumpSizes: [],
      isLoading: false,
    };
  },
  watch: {
    "Createform.motor_hp": "getHeadPumpSizes",
    "Createform.motor_category": "getHeadPumpSizes",
    "Createform.motor_type": "getHeadPumpSizes",
  },
  mounted() {
    if (this.roleName == "Super Admin") {
      this.companyId = this.$store.getters["settings/getCompanyId"];
    }
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("units/masters");
      masters = masters.data;
      masters.motor_types.forEach((motor) => {
        this.MotorTypes.push({
          id: motor.id,
          text: motor.description,
          value: motor.description,
        });
      });
      masters.pump_cateogires.forEach((pump) => {
        this.PumpCategories.push({
          id: pump.id,
          text: pump.description,
          value: pump.description,
        });
      });
      masters.motor_hps.forEach((motor_hp) => {
        this.MotorHps.push({
          id: motor_hp.id,
          text: motor_hp.description + ' HP',
          value: motor_hp.description,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        let units = [];
        if (this.roleName == "Super Admin") {
          const config = {
            headers: {
              "Company-id": this.companyId,
            },
          };
          units = await axios.post("/units", this.Createform, config);
        } else {
          units = await axios.post("/units", this.Createform);
        }
        this.units = units.data.data;
        this.$router.push("/units");
        this.isLoading = false;
      } catch (error) {
        if (error.response && error.response.status == 422) {
          const errors = error.response.data.errors;
          if (errors && errors.first_name || errors.location_controller || errors.latitude || errors.longitude) {
            this.e1 = 1;
          } else {
            this.e1 = 2;
          }
        }
        this.isLoading = false;
      }
    },
    async getHeadPumpSizes() {
      console.log("getHeadPumpSizes called with:", {
        motor_hp: this.Createform.motor_hp,
        motor_category: this.Createform.motor_category,
        motor_type: this.Createform.motor_type
      });
      
      this.HeadPumpSizes = [];
      if (
        this.Createform.motor_hp != null && this.Createform.motor_hp != "" &&
        this.Createform.motor_category != null && this.Createform.motor_category != ""
      ) {
        let query =
          "motor_hp=" +
          encodeURIComponent(this.Createform.motor_hp) +
          "&pump_category=" +
          encodeURIComponent(this.Createform.motor_category);
        
        // Add motor_type to query if selected
        if (this.Createform.motor_type != null && this.Createform.motor_type != "") {
          query += "&motor_type=" + encodeURIComponent(this.Createform.motor_type);
        }
        try {
          console.log("Fetching head pump sizes with query:", query);
          console.log("Full URL:", `head_pump_sizes?${query}`);
          
          let response = await axios.get(`head_pump_sizes?${query}`);
          console.log("API Response:", response.data);
          
          if (response.data && Array.isArray(response.data.data)) {
            if (response.data.data.length === 0) {
              console.warn("No head pump sizes found for the given criteria");
              return;
            }
            
            // Get unique sizes since we might have both AC and DC with same sizes
            const uniqueSizes = [...new Set(response.data.data.map(pump => pump.size))];
            uniqueSizes.sort((a, b) => a - b); // Sort numerically
            
            uniqueSizes.forEach((size) => {
              this.HeadPumpSizes.push({
                id: size,
                text: size + 'm',
                value: String(size),
              });
            });
            console.log("Head pump sizes loaded:", this.HeadPumpSizes.length, "unique options", this.HeadPumpSizes);
          } else {
            console.error("Invalid response data format:", response.data);
          }
        } catch (error) {
          console.error("Error fetching head pump sizes:", error);
          console.error("Error details:", error.response?.data);
        }
      } else {
        console.log("Conditions not met - motor_hp or motor_category is null/empty");
      }
    },
  },
};
</script>
